export { RelatedProjectIndicator } from "./related-project-indicator";
